module.exports = __webpack_public_path__ + "static/media/board-readwrite.b6bbe8a0.png";